import { get } from '../Services/http';
import { catchError } from './Error.action';
import { ACCESSORY_LOAD_ERROR, ACCESSORY_RECEIVE,ACCESSORY_MODAL_HIDE } from '../constants';

export const load = (articleNumber) => (dispatch, getState) => {

    return get('/api/accessory/'+ articleNumber)
        .then((response) => response.json())
        .then((data) => dispatch(receive(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: ACCESSORY_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (data) => ({
    type: ACCESSORY_RECEIVE,
    payload: {
        accessories: data,
        visible: true,
    },
});
export const hide = () => ({
    type: ACCESSORY_MODAL_HIDE,
    payload: {
        visible: false,
    },
});
